<template>

    <a :id="id">
        <img class="xxx" :style="bstyle" :height="bscale" @click="clicked" />
        <v-btn v-if="someunread" :style="cstyle" fab dark x-small :color="rating" @click="clicked">{{ unread }}</v-btn>
        <v-btn v-else :style="dstyle" fab x-small :color="rating" @click="clicked">{{ total }}</v-btn>
    </a>

</template>

<script>

export default {
    name: 'Button',
        props: {
        pitch: Number,
        yaw: Number,
        scale: String,
        source: String,
        id: String,
        rating: String,
        unread: String,
        total: String,
        calling: Object
        },
     mounted: function () {
        //this.$el.src = 'assets/' + this.source;
        var tb = this.$root.$el.firstChild;
         tb.src = 'assets/' + this.source;
         var tc = this.$root.$el.children[1];
         tc.src = 'assets/' + this.rating + '-alert.png';
         var g = 0;
    },
    data() {
        return {
        }
    },
    computed: {
        someunread() {
            if (this.unread.length > 0)
                return true;
            else
                return false;
        },
        bscale() {
            return this.scale;
            },
        cscale() {
            return '3%';
        },
        bstyle() {
            var xperc = this.yaw * 100;
            var yperc = this.pitch * 100;
            return 'position: absolute;' + ' left: ' + xperc + '%; top: ' + yperc + '%;';
            },
        cstyle() {
            var xperc = this.yaw * 100 + 2;
            var yperc = this.pitch * 100 - 3;
            if (this.unread === "*")
                return 'position: absolute;' + ' left: ' + xperc + '%; top: ' + yperc + '%; font-size: 1.5em;';
            else
                return 'position: absolute;' + ' left: ' + xperc + '%; top: ' + yperc + '%; font-size: 1.0em;';
        },
        dstyle() {
            var xperc = this.yaw * 100 + 2;
            var yperc = this.pitch * 100 - 3;
            return 'position: absolute;' + ' left: ' + xperc + '%; top: ' + yperc + '%; font-size: 0.9em;';
        },
    },
    methods: {
        clicked() {
            this.calling.overlayButtonClicked(this.id,0,0);
        }
    }
}

</script>

<style scoped>
    .xxx {
        position: absolute;
        background-color: transparent;
        border: none;
    }

</style>
